/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyWalletAIcon24Solid = forwardRef('MoneyWalletAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2 6.5A3.5 3.5 0 0 1 5.5 3h9a3.502 3.502 0 0 1 3.355 2.5H6A.75.75 0 0 0 6 7h12.5a3.5 3.5 0 0 1 3.491 3.25H17a3.75 3.75 0 1 0 0 7.5h5v.75a3.5 3.5 0 0 1-3.5 3.5h-13A3.5 3.5 0 0 1 2 18.5v-12Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 16.25h-5a2.25 2.25 0 0 1 0-4.5h5v4.5ZM19 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
});
